import { PasswordModal } from '@/scripts/optional/password-modal'
import { PasswordCountdown } from '@/scripts/theme/password-countdown'
import { PasswordPolicyModal } from '@/scripts/theme/password-policy-modal'
import { TsDOM as q} from '@/scripts/core/TsDOM'
q.safeDefineElement(PasswordModal)
q.safeDefineElement(PasswordCountdown)
q.safeDefineElement(PasswordPolicyModal)
